import { SwitchField as BaseSwitchField } from '../base/Switch';
import createField from './createField';

const SwitchField = createField(BaseSwitchField);

export default SwitchField;
